export const chatbotTranslations = {
    en: {
      welcomeMessage: "Welcome to Rapido Relief! 😊 How can I assist you today? Are you here as a:",
      welcomeOption1: "Patient seeking mental health support",
      welcomeOption2: "Healthcare provider looking for more information",
      welcomeOption3: "I need emergency support",
      welcomeOption4: "I'm looking for healthcare services near me",
  
      emergencySupportMessage: "It sounds like you're in an emergency situation. Who would you like to contact?",
      emergencyOption1: "Ambulance",
      emergencyOption2: "Doctor",
      emergencyOption3: "Family",
      emergencyOption4: "Activate emergency alert",
  
      ambulanceMessage: "Would you like me to notify the nearest ambulance service?",
      ambulanceOption1: "Yes, notify now",
      ambulanceOption2: "No, cancel",
  
      ambulanceConfirmedMessage: "An ambulance has been notified. Stay safe!",
  
      mentalHealthMessage: "Would you like resources for mental health or self-help tools?",
      mentalHealthOption1: "Articles & videos",
      mentalHealthOption2: "Coping strategies",
      mentalHealthOption3: "No, thank you",
  
      mentalHealthArticlesMessage: "Here are some resources to help you. [Link to articles]",
      mentalHealthArticlesOption1: "Back to Menu",
  
      copingStrategiesMessage: "Here are coping strategies: mindfulness, staying active, etc.",
      copingStrategiesOption1: "Back to Menu",
    },
    pt: {
        welcomeMessage: "Bem-vindo ao Rapido Relief! 😊 Como posso ajudá-lo hoje? Você está aqui como:",
        welcomeOption1: "Paciente em busca de apoio para saúde mental",
        welcomeOption2: "Profissional de saúde procurando mais informações",
        welcomeOption3: "Preciso de apoio de emergência",
        welcomeOption4: "Estou procurando serviços de saúde próximos",
    
        emergencySupportMessage: "Parece que você está em uma situação de emergência. Quem você gostaria de contatar?",
        emergencyOption1: "Ambulância",
        emergencyOption2: "Médico",
        emergencyOption3: "Família",
        emergencyOption4: "Ativar alerta de emergência",
    
        ambulanceMessage: "Gostaria que eu notificasse o serviço de ambulância mais próximo?",
        ambulanceOption1: "Sim, notifique agora",
        ambulanceOption2: "Não, cancelar",
    
        ambulanceConfirmedMessage: "Uma ambulância foi notificada. Fique seguro!",
    
        mentalHealthMessage: "Você gostaria de recursos para saúde mental ou ferramentas de autoajuda?",
        mentalHealthOption1: "Artigos e vídeos",
        mentalHealthOption2: "Estratégias de enfrentamento",
        mentalHealthOption3: "Não, obrigado",
    
        mentalHealthArticlesMessage: "Aqui estão alguns recursos para ajudá-lo. [Link para artigos]",
        mentalHealthArticlesOption1: "Voltar ao Menu",
    
        copingStrategiesMessage: "Aqui estão estratégias de enfrentamento: mindfulness, manter-se ativo, etc.",
        copingStrategiesOption1: "Voltar ao Menu",
      },

    es: {
      welcomeMessage: "¡Bienvenido a Rapido Relief! 😊 ¿Cómo puedo ayudarte hoy? ¿Estás aquí como:",
      welcomeOption1: "Paciente en busca de apoyo para la salud mental",
      welcomeOption2: "Proveedor de salud buscando más información",
      welcomeOption3: "Necesito apoyo de emergencia",
      welcomeOption4: "Busco servicios de salud cerca de mí",
  
      emergencySupportMessage: "Parece que estás en una situación de emergencia. ¿A quién te gustaría contactar?",
      emergencyOption1: "Ambulancia",
      emergencyOption2: "Doctor",
      emergencyOption3: "Familia",
      emergencyOption4: "Activar alerta de emergencia",
  
      ambulanceMessage: "¿Quieres que notifique al servicio de ambulancias más cercano?",
      ambulanceOption1: "Sí, notificar ahora",
      ambulanceOption2: "No, cancelar",
  
      ambulanceConfirmedMessage: "Se ha notificado una ambulancia. ¡Mantente a salvo!",
  
      mentalHealthMessage: "¿Te gustaría recursos para la salud mental o herramientas de autoayuda?",
      mentalHealthOption1: "Artículos y videos",
      mentalHealthOption2: "Estrategias de afrontamiento",
      mentalHealthOption3: "No, gracias",
  
      mentalHealthArticlesMessage: "Aquí hay algunos recursos para ayudarte. [Enlace a artículos]",
      mentalHealthArticlesOption1: "Volver al menú",
  
      copingStrategiesMessage: "Aquí hay estrategias de afrontamiento: atención plena, mantenerse activo, etc.",
      copingStrategiesOption1: "Volver al menú",
    },
    nl: {
        welcomeMessage: "Welkom bij Rapido Relief! 😊 Hoe kan ik u vandaag helpen? Bent u hier als:",
        welcomeOption1: "Patiënt die ondersteuning voor mentale gezondheid zoekt",
        welcomeOption2: "Zorgverlener die meer informatie zoekt",
        welcomeOption3: "Ik heb noodhulp nodig",
        welcomeOption4: "Ik zoek gezondheidsdiensten in de buurt",
    
        emergencySupportMessage: "Het lijkt erop dat u in een noodsituatie bent. Wie wilt u contacteren?",
        emergencyOption1: "Ambulance",
        emergencyOption2: "Dokter",
        emergencyOption3: "Familie",
        emergencyOption4: "Noodmelding activeren",
    
        ambulanceMessage: "Wilt u dat ik de dichtstbijzijnde ambulancedienst op de hoogte stel?",
        ambulanceOption1: "Ja, nu melden",
        ambulanceOption2: "Nee, annuleren",
    
        ambulanceConfirmedMessage: "Een ambulance is ingelicht. Blijf veilig!",
    
        mentalHealthMessage: "Wilt u middelen voor mentale gezondheid of zelfhulpmiddelen?",
        mentalHealthOption1: "Artikelen en video's",
        mentalHealthOption2: "Copingstrategieën",
        mentalHealthOption3: "Nee, bedankt",
    
        mentalHealthArticlesMessage: "Hier zijn enkele hulpmiddelen voor u. [Link naar artikelen]",
        mentalHealthArticlesOption1: "Terug naar menu",
    
        copingStrategiesMessage: "Hier zijn copingstrategieën: mindfulness, actief blijven, enz.",
        copingStrategiesOption1: "Terug naar menu",
      },
  };